'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutCluster, LayoutStack } from 'design-system/client';
import { useTranslations } from 'next-intl';
import styles from './IFrameHolderFields.module.css';
import DonationFormRequiredField from '@/donationPages/_dependencies/components/DonationFormRequiredField';
import FormInput from '@/form/FormInput';
function IFrameHolderFields() {
  const $ = _c(18);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("nextjs.donate.attributes.first_name");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <DonationFormRequiredField name="first_name" title={t0} as={FormInput} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("nextjs.donate.attributes.last_name");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <DonationFormRequiredField name="last_name" title={t2} as={FormInput} />;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <LayoutCluster space="300" className={styles.nameContainer}>{t1}{t3}</LayoutCluster>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("nextjs.donate.attributes.email");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <DonationFormRequiredField name="email" type="email" title={t5} as={FormInput} />;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <LayoutStack space="400">{t4}{t6}</LayoutStack>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
export default IFrameHolderFields;